<template>
  <RCard class="products-tab">
    <FormCreateProduct
      :showing="showForm"
      :publisher="publisher"
      context="publisher"
      @close="showForm = false"
      @close-with-acquisition="startAcquisition($event)"
      @create="refresh"
    />

    <FormSubscriptionPeriod
      :showing="showSubscriptionModal"
      :original-tasks="taskApplicability"
      :product-id="productId"
      :disable-properties="['product_id']"
      :has-end-action="true"
      @go="goToPage({ name: 'subscription', params: { id: $event } })"
      @close="showSubscriptionModal = false"
    />

    <AgGrid ref="agGrid" :options="gridOptions" :api-request="infiniteScrollRequest" @ready="agGrid = $event">
      <template #header>
        <Grid gaf="column" justify-content="space-between">
          <Grid gaf="column" align-items="center" gap="var(--r-space-md)">
            <div class="text-subtitle-1 text-secondary-2">Products</div>
            <ChipFilters v-model="filters" />
          </Grid>

          <div class="row items-center">
            <RBtn size="small" type="text" @click="showForm = true">
              <div class="text-overline-1 text-secondary-1">Create new product</div>
            </RBtn>

            <ShowHideCols :ag-grid="agGrid" class="q-ml-sm" />
          </div>
        </Grid>
      </template>
    </AgGrid>
  </RCard>
</template>

<script>
import * as apiTo from '@/modular-api'
// Mixins
import gridOptions from './gridOptions'
// Libraries
import { mapGetters } from 'vuex'
// Components
import AgGrid from '@/ag-grid/AgGrid'
import ShowHideCols from '@/ag-grid/components/show-hide-cols/ShowHideCols'
import { FormCreateProduct, FormSubscriptionPeriod } from '@components/forms'
import ChipFilters from './components/ChipFilters'

export default {
  components: {
    AgGrid,
    ShowHideCols,
    FormCreateProduct,
    FormSubscriptionPeriod,
    ChipFilters
  },

  mixins: [gridOptions],

  props: {
    id: [Number, String] // from route
  },

  data() {
    return {
      agGrid: null,
      showForm: false,
      showSubscriptionModal: false,
      productId: null,
      filters: ['current', 'oneTimePurchase']
    }
  },

  computed: {
    ...mapGetters('subscriptions/subscriptionPeriods', ['taskApplicability']),
    ...mapGetters('publisher-show', ['publisher'])
  },

  watch: {
    filters: 'refresh'
  },

  methods: {
    infiniteScrollRequest(request) {
      return apiTo.GET_PUBLISHER_PRODUCTS(this.id, request, this.filters)
    },

    startAcquisition(event) {
      this.showForm = false
      this.productId = event.data ? event.data.id : event
      this.showSubscriptionModal = true
    },

    goToPage(route) {
      return this.$router.push(route)
    },

    refresh() {
      this.$refs.agGrid.purgeServerSideCache()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.products-tab {
  @include table-with-no-filters;
}
</style>
